import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Table, ButtonGroup, IconButton, Icon, Panel, Row, Col, Grid, Avatar } from 'rsuite'
import pathname from '../../../constants/pathname'
import AppContext from '../../../context/AppContext'
import { getAllProject, searchAllProject } from '../../../redux/actions/dashboard'
import '../styles.less'
import ProjectDataTable from '../../dataTable/ProjectDataTable'
import CommitteeDataTable from './CommitteeDataTable'
import { startLoading, doneLoading } from '../../../utils/loading'
import {
  getMasterAccountType,
  deleteMasterAccountType,
} from '../../../redux/actions/masterAccountType'

const { Column, HeaderCell, Cell } = Table

export default function CommitteeAccountSearchAndTableWidget({
  schema: _schema,
  handleOnEdit,
  handleOnRemove,
  ...props
}) {
  const contextValue = React.useContext(AppContext)
  const history = useHistory()
  const [schema, setSchema] = useState(_schema)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [loading, setloading] = useState(false)

  useEffect(() => {
    _schema && setSchema(_schema)
  }, [_schema])

  const handleGetSchema = async () => {
    setIsLoading(true)
    try {
      // const response = await getAllProject(5, 1)
      // setSchema(response)
      setSchema(mockSchema)
    } catch (e) {
      setError({})
    }
    setIsLoading(false)
  }

  const handleOnReload = async (pagesize, pagenumber, accountName, accountYear) => {
    startLoading()
    setloading(true)
    try {
      // const response = await searchAllProject(pagesize, pagenumber, accountName, accountYear)
      // if (response) {
      //   setSchema(response)
      // }
      setSchema(mockSchemaSearch)
    } catch (e) {
      console.log('e', e)
    }
    setloading(false)
    doneLoading()
  }

  const handleSearchCommittee = async (pagesize, pagenumber, accountName, accountYear) => {
    startLoading()
    setloading(true)
    try {
      const response = await getMasterAccountType(accountName, accountYear)
      if (response) {
        setSchema(response)
      }
      // setSchema(mockSchemaSearch)
    } catch (e) {
      console.log('e', e)
    }
    setloading(false)
    doneLoading()
  }

  const onSingleSubmit = (obj) => {
    // console.log('id', obj.ig)
    //history.push(`${pathname.proposal.overview.overviewCoworker}/${obj.id}`)
    // history.push(`${pathname.proposal.overview.overviewCoworker}/mock-reveiw`)
  }

  return (
    <>
      {schema && (
        <CommitteeDataTable
          schema={schema}
          onSingleSubmit={onSingleSubmit}
          pagination={true}
          onReload={handleOnReload}
          loading={loading}
          hiddenColStatus={true}
          onSearchCommittee={handleSearchCommittee}
          onEdit={handleOnEdit}
          onRemove={handleOnRemove}
        ></CommitteeDataTable>
      )}
    </>
  )
}

const mockSchema = {
  header: 'รายการบัญชีคณะกรรมการ',
  searchPanel: {
    header: 'เงื่อนไขการค้นหาบัญชีคณะกรรมการ',
    accountName: {
      name: 'accountName',
      label: 'ชื่อบัญชีคณะกรรมการ',
      value: '',
      hint: 'กรอกชื่อบัญชีคณะกรรมการ',
    },
    accountYear: {
      name: 'accountYear',
      label: 'ปีงบประมาณ',
      value: '',
      hint: 'กรอกปีงบประมาณ',
    },
  },
  values: null,
  forms: {
    header: 'เพิ่มข้อมูลบัญชีคณะกรรมการ',
    id: '',
    accountName: {
      name: 'accountName',
      label: 'ชื่อบัญชีคณะกรรมการ',
      value: '',
      validators: [
        {
          type: 'REQUIRED',
          value: null,
          errorMessage: 'กรุณากรอก ชื่อบัญชีคณะกรรมการ',
        },
      ],
    },
    accountYear: {
      name: 'accountYear',
      label: 'ปีงบประมาณ',
      value: '',
      validators: [],
    },
  },
}

const mockSchemaSearch = {
  header: 'รายการบัญชีคณะกรรมการ',
  totalSize: 409,
  searchPanel: {
    header: 'เงื่อนไขการค้นหาบัญชีคณะกรรมการ',
    accountName: {
      name: 'accountName',
      label: 'ชื่อบัญชีคณะกรรมการ',
      value: '',
      hint: 'กรอกชื่อบัญชีคณะกรรมการ',
    },
    accountYear: {
      name: 'accountYear',
      label: 'ปีงบประมาณ',
      value: '',
      hint: 'กรอกปีงบประมาณ',
    },
  },
  values: [
    {
      id: '0001',
      sequence: '1',
      accountName: 'บัญชีแผน-บัญชีคณะกรรมการ คณะที่ 1',
      accountYear: '2564',
    },
    {
      id: '0002',
      sequence: '2',
      accountName: 'บัญชีแผน-บัญชีคณะกรรมการ คณะที่ 2',
      accountYear: '2564',
    },
    {
      id: '0003',
      sequence: '3',
      accountName: 'บัญชีแผน-บัญชีคณะกรรมการ คณะที่ 3',
      accountYear: '2564',
    },
    {
      id: '0004',
      sequence: '4',
      accountName: 'บัญชีแผน-บัญชีคณะกรรมการ คณะที่ 4',
      accountYear: '2564',
    },
    {
      id: '0005',
      sequence: '5',
      accountName: 'บัญชีแผน-บัญชีคณะกรรมการ คณะที่ 5',
      accountYear: '2564',
    },
  ],
  forms: {
    header: 'เพิ่มข้อมูลบัญชีคณะกรรมการ',
    id: '',
    accountName: {
      name: 'accountName',
      label: 'ชื่อบัญชีคณะกรรมการ',
      value: '',
      validators: [
        {
          type: 'REQUIRED',
          value: null,
          errorMessage: 'กรุณากรอก ชื่อบัญชีคณะกรรมการ',
        },
      ],
    },
    accountYear: {
      name: 'accountYear',
      label: 'ปีงบประมาณ',
      value: '',
      validators: [],
    },
  },
}
